// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gItPTeRw_S05KWa1gRX3{align-items:center;gap:12px;padding:22px 0 26px;display:flex}.gItPTeRw_S05KWa1gRX3 .cvJ3p9OYwYEBUb2eBZZ5{flex-direction:column;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"memberWrap": `gItPTeRw_S05KWa1gRX3`,
	"memberInfo": `cvJ3p9OYwYEBUb2eBZZ5`
};
export default ___CSS_LOADER_EXPORT___;
